// Single source of truth for product branding (display layer only).
export const PRODUCT_NAME = 'Fritech Ai Business Platform';
export const BRAND = 'Fritech';
export const SLOGAN = 'Future-Ready Innovative Technology';
// The assistant's user-facing name in every shell (rep-app program, spec
// section 9). Internal ids stay: copilot, /ai/*, help article ai-assistant.
export const ASSISTANT_NAME = 'AI Companion';
